// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgj_a bhi_bi"};